import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHead, Icon } from '../ui';
import { WHY_US } from '../../data/home';

export default function WhyChooseUs() {
  const { t } = useTranslation();
  return (
    <div className="why card">
      <SectionHead eyebrow={t('Why Choose Us')} title={t('Your Journey, Our Priority')} as="h3" />
      <ul className="why-list">
        {WHY_US.map((w) => (
          <li key={w}><Icon name="circle-check" size={20} />{t(w)}</li>
        ))}
      </ul>
    </div>
  );
}
